import { render, staticRenderFns } from "./NewEditTurmaPage.vue?vue&type=template&id=913d88fc&scoped=true"
import script from "./NewEditTurmaPage.vue?vue&type=script&lang=js"
export * from "./NewEditTurmaPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditTurmaPage.vue?vue&type=style&index=0&id=913d88fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913d88fc",
  null
  
)

export default component.exports